import {
	KameleoonClient,
	CustomData,
	FeatureFlagType,
	KameleoonVariationType,
	SDKConfigurationType,
	Environment,
  
} from "@kameleoon/javascript-sdk"

// Set the AB test object
import setActiveABFeatures from "./setActiveABFeatures"

// Config
import siteCode from "@/config/ABTestSiteCode"
import { ABTestExperiments , IExperiment, IApiAction} from "@/config/ABTestExperimentConfig" // Adjust the import path as necessary

// Cookies
import Cookies from "js-cookie"

// Types
type InitMode = "webExperiment" | "featureFlag"

async function init(mode: InitMode) {
	if (mode === "webExperiment") {
		initWebExperiment()
	} else if (mode === "featureFlag") {
		initFeatureFlag()
	}
}


function initWebExperiment(): void {
	//  ** NO COOKIE CASE **
  ABTestExperiments.forEach(experiment => {
      const cookieName = experiment.cookieName

      const intialCookieValue: string | undefined = Cookies.get(cookieName)
      if(intialCookieValue) {
        console.log(`cookie already set for experiment with id ${experiment.id}`)
        return 
      }

      // 1. we set the version (A OR B) by default
      Cookies.set(cookieName, experiment.defaultCookieValue, {path: '/'})
      const counter: number = 1000
      // 2. Wait for Kameleoon to load
      const interval: number = setInterval(() => {
        if (window.Kameleoon) clearInterval(interval)
        // 3. retrieve the actual active feature
        const activeExperiments: IApiAction[] = window.Kameleoon.API.Experiments.getActive()
        if(!activeExperiments || !activeExperiments.length) {
          console.log("No active experiments")
          return
        }
  
        const activeExperiment: IApiAction | undefined = activeExperiments.find((active: IApiAction) => active.id === experiment.id)
        if(!activeExperiment) {
          console.error(`no active expriment with id ${experiment.id}`)
          return
        }

        const activeVariantId: number | undefined = activeExperiment.associatedVariation.id

        if(!activeVariantId) {
          console.error(`no active activeVariant`)
          return
        }


        // 3. set the cookie for the actual active feature
        const activeVariantCookieValue: string = getActiveVariantCookieValue(activeVariantId, experiment)
        // 4. if we have a differnce between the actual version and the set cookie(version), we cancel the conversion and reload the page
        if(activeVariantCookieValue !== experiment.defaultCookieValue) {
          window.Kameleoon.API.Goals.cancelConversion(experiment.goalId);
          location.reload()
        }
      }, counter)
    })


}

function getActiveVariantCookieValue(activeVariantId: number, experiment: IExperiment): string {
  let cookieValue = "inactive"
  if(activeVariantId === experiment.activeVariantId) {
    cookieValue = "active"
  }else if(activeVariantId === experiment.inactiveVariantId) {
    cookieValue = "inactive"
  }
  return cookieValue

}

async function initFeatureFlag(): Promise<void> {
	const configuration: Partial<SDKConfigurationType> = {
		updateInterval: 20, 
		environment: Environment.Production,
		// domain: '.example.com',
	}

	const client = new KameleoonClient({
		siteCode,
		configuration,
	})

	await client.initialize()
	const visitorCode: string = client.getVisitorCode()
	const customData = new CustomData(0, "my_data")
	client.addData(visitorCode, customData)

	// Mandatory for sending the data to Kameleoon
	const allFeatures: FeatureFlagType[] = client.getFeatureFlags()
	allFeatures.forEach((feature: FeatureFlagType) =>
		client.getFeatureFlagVariationKey(visitorCode, feature.key)
	)
	const activeFeatures: Map<string, KameleoonVariationType> =
		client.getActiveFeatureFlags(visitorCode)

	const engineCode: string = client.getEngineTrackingCode(visitorCode)

	client.flush(visitorCode)
	setActiveABFeatures(activeFeatures)

	const script = document.createElement("script")
	script.textContent = engineCode
	document.body.appendChild(script)
}

export default init
